import gql from 'graphql-tag'

import {query} from '../helpers/apollo'
import axios from '../helpers/axios'

import {SimpleMedia} from './fragment'

const debug = false

export const searchDistributor = function(params={}){
	if(debug) console.log('[API]', 'searchDistributor', params)

	let limit = params.limit || 200
	let skip = params.skip || 0

	return query({
		fetchPolicy: 'network-only',
		variables: {
			query: params.query || '',
			limit,
			skip: skip * limit
		},

		query: gql`
			query($limit:Int, $skip:Int, $query:String){
			  searchDistributor(limit:$limit, skip:$skip, query:$query){
			    total
			    limit
			    skip 
			    data{ 
			      _id
			      name
			      logoMedia{
		          ...SimpleMedia
		        } 
			    }
			  }
		  }
		  ${SimpleMedia}
		`
	})
		.then(res => res.data.searchDistributor)
		.catch(err => console.log('🔥 GRAPHQL', err))

}

export const getFullDistributor = function(params={}){
	if(debug) console.log('[API]', 'getFullDistributor', params)

	return query({
		fetchPolicy: 'network-only',
		variables: {
			limit: 2000,
			skip: 0,
			query: ''
		},
		query: gql`
			query($limit:Int, $skip:Int, $query:String){
			  searchDistributor(limit:$limit, skip:$skip, query:$query){
			    data{ 
			      _id
			      name
			    }
			  }
		  }
		`
	})
		.then(res => res.data.searchDistributor)
		.catch(err => console.log('🔥 GRAPHQL', err))

}

export const getDistributor = function(_id){
	if(debug) console.log('[API]', 'getDistributor', {_id})

	return query({
		fetchPolicy: 'network-only',
		variables: {
			_id
		},
		query: gql`
			query($_id:String!){
		    getDistributorById(_id:$_id){
		      _id
		      name
		      logo
		      logoMedia{
		        ...SimpleMedia
		      }
		    }
			}
			
			${SimpleMedia}
		`
	})
		.then(res => res.data.getDistributorById)
		.catch(err => console.log('🔥 GRAPHQL', err))
}

export const saveDistributor = async function(data){
	if(debug) console.log('[API]', 'saveDistributor', data)

	return (data._id
			? axios.post(`/distributor/${data._id}`, data)
			: axios.put(`/distributor`, data)
	)
		.then(res => res.data)

}

export const removeDistributor = function(_id){
	if(debug) console.log('[API]', 'removeDistributor', _id)

	return axios.delete(`/distributor/${_id}`)
		.then(res => res.data)

}
